import {
  alluvialdiagram,
  arcdiagram,
  barchart,
  barchartmultiset,
  barchartstacked,
  beeswarm,
  boxplot,
  bubblechart,
  bumpchart,
  chorddiagram,
  circlepacking,
  circularDendrogram,
  contourPlot,
  convexHull,
  dendrogram,
  ganttChart,
  hexagonalBinning,
  horizongraph,
  linechart,
  matrixplot,
  parallelcoordinates,
  piechart,
  radarchart,
  sankeydiagram,
  slopechart,
  streamgraph,
  sunburst,
  treemap,
  violinplot,
  voronoidiagram,
  voronoitreemap,
} from '@rawgraphs/rawgraphs-charts'

import { calendarHeatmap } from '@rawgraphs/rawgraphs-calendar-heatmap'
import pointMap from './charts/geo/pointMap'
import forceDirectedGraph from './charts/forceDirectedGraph'

// Upstream bug: ganttChart.metadata.id is undefined in @rawgraphs/rawgraphs-charts
const patchedGanttChart = { ...ganttChart, metadata: { ...ganttChart.metadata, id: 'rawgraphs.ganttChart' } }

// New charts, not included into first release.
// Comment at necessity.
let charts = [
  alluvialdiagram,
  arcdiagram,
  barchart,
  barchartmultiset,
  barchartstacked,
  beeswarm,
  boxplot,
  bubblechart,
  bumpchart,
  calendarHeatmap,
  chorddiagram,
  circlepacking,
  circularDendrogram,
  contourPlot,
  convexHull,
  dendrogram,
  patchedGanttChart,
  hexagonalBinning,
  horizongraph,
  linechart,
  matrixplot,
  parallelcoordinates,
  piechart,
  pointMap,
  forceDirectedGraph,
  radarchart,
  sankeydiagram,
  slopechart,
  streamgraph,
  sunburst,
  treemap,
  violinplot,
  voronoidiagram,
  voronoitreemap,
]

export default charts
